import axios from 'axios';
import host from '../config/api-host';
import router from '../router';

window.$accountAPI = axios.create({
	baseURL: environment.webApi,
	withCredentials: true,
});

const globalApi = axios.create({
		baseURL: host.globalApiHost,
	}),
	getCountryList = async () => {
		const config = await axios
				.get(`${environment.webApi}/v2/configurations`)
				.then((res) => res.data),
			list = await globalApi
				.get(`/country/v1/region-countries?membership_no=${config.membership_no}`)
				.then((res) => res.data)
				.catch(() => []);
		return list;
	},
	getCountryCode = () => globalApi.get('/geoip/v1/country').then((res) => res.data),
	pluginAPI = {
		install(Vue) {
			Vue.prototype.$globalAPI = {
				getCountryList,
				getCountryCode,
			};

			window.$accountAPI.interceptors.response.use(
				(response) => response,
				(error) => {
					let errorCode = 'unknown';
					if (error.response && typeof error.response.data === 'object') {
						const errorData = error.response.data;
						console.error(
							`api error: ${error.config.method} - ${error.config.url} => ${
								error.response.data
							}`
						);
						// this is for login redirection due to login required action taken after page routing
						if (!router.history.pending && errorData.code === 'LOGIN_REQUIRED') {
							router.push({
								name: 'login',
								query: {
									return_url: document.URL,
								},
								params: {
									locale: window.App.$i18n.locale,
								},
							});
						}
						errorCode = errorData.code || errorData.status;
					} else if (error.message === 'Network Error') errorCode = 'NETWORK_ERROR';
					else if (error.code === 'ECONNABORTED') errorCode = 'TIMEOUT';

					return Promise.reject(errorCode);
				}
			);
			Vue.prototype.$accountAPI = window.$accountAPI;

			// currently, it is only for tracking each action point
			Vue.prototype.$grecaptchaV3 = (action) => {
				grecaptcha.ready(() => {
					grecaptcha.execute('6Lc60IgUAAAAAL3vtKNcWZc9B0DFAQaXKPcyxqsX', { action });
				});
			};
		},
	};

export default pluginAPI;



// WEBPACK FOOTER //
// ./src/plugins/api-helper.js